export class Saison {
	id?: number;
	nom: string = "";
	date_debut: string = ""; // Format YYYY-MM-DD
	date_fin: string = ""; // Format YYYY-MM-DD
}
